import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from './auth.state';

// private selectors
const authStateSelector = createFeatureSelector<AuthState>('authState');

export const guid = createSelector(authStateSelector, authState => !!authState && authState.guid);
